import { render, staticRenderFns } from "./ProjectsAsset.vue?vue&type=template&id=c9d48dac&"
import script from "./ProjectsAsset.vue?vue&type=script&lang=js&"
export * from "./ProjectsAsset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports